import {
  FETCH_ALL_METRICS,
  FETCH_METRIC,
  CREATE_METRIC,
  UPDATE_METRIC,
  DELETE_METRIC,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const metricsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_METRICS}_PENDING`:
      return { ...state, message: null, loading: true, data: [] };

    case `${FETCH_ALL_METRICS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : [];
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_METRICS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const metricReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_METRIC}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_METRIC}_FULFILLED`:
      const result = action.payload.data?.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_METRIC}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createMetricReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_METRIC}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_METRIC}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_METRIC}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateMetricReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_METRIC}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_METRIC}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_METRIC}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteMetricReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_METRIC}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_METRIC}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_METRIC}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
